import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

// Default white background with a small box shadow.
export const Shadow = styled.div`
    background: ${theme.colors.primaryWhite};
    border-radius: 4px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
`;
